<template>
  <div class="orders">
    <van-nav-bar title="订单列表" left-arrow @click-left="goBack" />
    <van-tabs v-model="active">
      <van-tab
        title="未退款"
        name="todo"
        :to="{ name: 'orderList', query: { status: 'todo' } }"
      >
        <van-list
          class="order-list"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            @click="goToDetail(item)"
            class="order-item"
            v-for="item in orderList"
            :key="item.id"
          >
            <div class="order-title">
              <h3>{{ item.ticketModelName }}</h3>
              <span>详情</span>
            </div>
            <div class="order-detail clearfix">
              <div class="order-info">
                <span class="order-info-key">下单日期：</span>
                <span>{{ formatDay(item.billDate) }}</span>
              </div>
              <div class="order-info">
                <span class="order-info-key">订单渠道：</span>
                <span>{{ item.buyerCorpCode }}</span>
              </div>
              <div class="order-info">
                <span class="order-info-key">可用日期：</span>
                <span>{{ formatDay(item.playDate) }}</span>
              </div>
              <div class="order-info">
                <span class="order-info-key">检票状态：</span>
                <span>{{ checkStatus(item.checkFlag) }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
      <van-tab
        title="已退款"
        name="done"
        :to="{ name: 'orderList', query: { status: 'done' } }"
      >
        <van-list
          class="order-list"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoadDone"
        >
          <div
            @click="goToDetail(item)"
            class="order-item"
            v-for="item in orderListDone"
            :key="item.id"
          >
            <div class="order-title">
              <h3>{{ item.ticketModelName }}</h3>
              <span>详情</span>
            </div>
            <div class="order-detail clearfix">
              <div class="order-info">
                <span class="order-info-key">退票渠道：</span>
                <span>{{ item.canalCode }}</span>
              </div>
              <div class="order-info">
                <span class="order-info-key">可用日期：</span>
                <span>{{ formatDay(item.playDate) }}</span>
              </div>
              <div class="order-info">
                <span class="order-info-key">退票状态：</span>
                <span>{{ returnStatus(item) }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { formatDay, checkStatus, returnStatus } from '@/utils';

export default {
  name: 'OrderList',
  components: {},
  data() {
    return {
      loading: false,
      finished: false,
      active: 'todo'
    };
  },
  computed: {
    ...mapGetters(['orderList', 'orderListDone'])
  },
  created() {
    this.load(this.$route);
  },
  watch: {
    $route: 'load',
    active() {
      if (this.active === 'todo') {
        this.onLoad();
      } else {
        this.onLoadDone();
      }
    }
  },
  methods: {
    ...mapActions(['getOrderList', 'getOrderListDone']),
    checkStatus,
    returnStatus,
    formatDay,
    goBack() {
      this.$router.replace({ name: 'login' });
    },
    load(route) {
      this.active = route.query.status || 'todo';
    },
    refresh({ name }) {
      this.$router.replace({
        name: 'orderList',
        query: {
          status: name
        }
      });
    },
    async onLoad() {
      this.loading = true;
      this.finished = false;
      await this.getOrderList();
      this.loading = false;
      this.finished = true;
    },
    async onLoadDone() {
      this.loading = true;
      this.finished = false;
      await this.getOrderListDone();
      this.loading = false;
      this.finished = true;
    },
    goToDetail(item) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: item.billNo
        }
      });
    }
  }
};
</script>

<style lang="less">
.orders {
  background-color: #f7f7f7;
  min-height: 100vh;
}
.order-title {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  line-height: 1;
  h3 {
    font-size: 15px;
    color: #333;
    margin: 0;
  }
  span {
    color: #7090ff;
    flex-shrink: 0;
    font-size: 14px;
  }
}
.order-item {
  padding: 15px 15px 5px;
  background-color: #fff;
  margin: 8px 0;
}

.order-info {
  float: left;
  width: 50%;
  color: #333;
  font-size: 12px;
  margin-bottom: 10px;
}
.order-info-key {
  color: #999;
}
</style>
